import React, { useEffect, createRef, useState } from 'react'
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { NEW, VIEW, UPDATE } from '../../assets/Constants/actionsTypes'
import { useTranslation } from 'react-i18next';
import './model.css';

const ModelModal = (props) => {
    /**We use the useTranslation hook to update the text when the language changes */
    const { t } = useTranslation('common');
    // we create a reference for the modal
    const window = createRef();
    // this variable allow us know if the save button will be shown or not
    const [showSave, setShowSave] = useState(false);
    // if is in UPDATE mode
    const [isUpdate, setIsUpdate] = useState(false);
    // inputs in the modal and its state
    const [code, setCode] = useState('');
    const [name, setName] = useState('');

    // here you define the configuration that the modal will have. this depends on the type with which it was opened.
    useEffect(() => {
        if (props.type === NEW) {
            setShowSave(true);
            // Clean and refresh the state of inputs
            setName('');
            setCode('');
        } else {
            if (props.data) {
                //* Setting data
                setName(props.data.name);

                setCode(props.data.code);

                if (props.type === VIEW) {
                    setShowSave(false)
                } else {
                    if (props.type === UPDATE) {
                        setShowSave(true);
                        setIsUpdate(true);
                    }
                }
            } else {
                props.toggleWindow();
            }
        }

    }, [props])

    // with this we make sure to always hide the maximize and minimize buttons.
    useEffect(() => {
        if (window) {
            hideButtons();
        }
    })

    // with this we hide the maximize and minimize buttons.
    const hideButtons = () => {
        let maximizeButton = window.current.windowElement.querySelector(
            ".k-i-window-maximize"
        ).parentElement;
        maximizeButton.style.visibility = "hidden";

        let minimizeButton = window.current.windowElement.querySelector(
            ".k-i-window-minimize"
        ).parentElement;
        minimizeButton.style.visibility = "hidden";
    }

    return (
        <>
            <Window
                className="ilo-k-window"
                initialHeight={320}
                modal={true}
                title={t('model.modalTitle')}
                resizable={false}
                draggable={false}
                doubleClickStageChange={false}
                onClose={() => {
                    props.toggleWindow();
                }}
                ref={window}
            >
                <div className="container-fluid m-1">
                    <div className="row">
                        <div className="col-md-1" ></div>
                        <div className="col-md-10">

                            <div className="row justify-content-center mb-2">
                                <label className={`col-10 col-form-label ${showSave && !isUpdate ? 'ilo_lbl_general required' : 'ilo_lbl_general'}`}>{t('model.code_input')}</label>
                                <div className="col-10">
                                    <input
                                        type="text"
                                        disabled={!showSave || isUpdate}
                                        className="form-control ilo-input ilo-modal-input"
                                        placeholder={t('model.code_input')}
                                        value={code}
                                        onChange={(e) => setCode(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="row justify-content-center mb-2">
                                <label className={`col-10 col-form-label ${showSave && !isUpdate ? 'ilo_lbl_general required' : 'ilo_lbl_general'}`}>{t('model.name_input')}</label>
                                <div className="col-10">
                                    <input
                                        type="text"
                                        disabled={!showSave || isUpdate}
                                        className="form-control ilo-input ilo-modal-input"
                                        placeholder={t('model.name_input')}
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                            </div>
                            <WindowActionsBar layout="end">
                                {showSave &&
                                    <button
                                        onClick={() => {
                                            const data = {
                                                modelid: isUpdate ? props.data.modelid : 0,
                                                code,
                                                name
                                            }
                                            props.onSave(data)
                                        }}
                                        className="btn btn-primary ilo-btn"
                                    >{t('modals.save_btn')}</button>
                                }

                                <button onClick={props.toggleWindow} className="btn btn-primary ilo-btn">{showSave ? t('modals.cancel_btn') : t('modals.close_btn')}</button>
                            </WindowActionsBar>

                        </div>
                        <div className="col-md-1" ></div>
                    </div>
                </div>
            </Window>
        </>
    );
}

export default ModelModal